import React from "react";
import WidgetChildren from "./WidgetChildren";
import IWidgetProps from "../../../../model/interface/widget/IWidgetProps";


class ColumnWidget extends React.Component<IWidgetProps> {
    render() {
        return (
           <>
               <WidgetChildren {...this.props}/>
           </>
        );
    }
}

export default ColumnWidget